import { render, staticRenderFns } from "./crudInstancesSystem.vue?vue&type=template&id=b1637a9c&"
import script from "./crudInstancesSystem.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystem.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports